import Loadable from "app/components/Loadable";
import { lazy } from "react";

const Basicinfo = Loadable(lazy(() => import("./Basicinfo")));
const AddSkills = Loadable(lazy(() => import("./AddSkill")));
const ChooseSkill = Loadable(lazy(() => import("./ChooseSkill")));
const AddIndustryv1 = Loadable(lazy(() => import("./AddIndustryv1")));
const PrimaryIndustry = Loadable(lazy(() => import("./PrimaryIndustry")));
const AddProjectv2 = Loadable(lazy(() => import("./AddProjectv2")));
const AddprojCollaboratorsv2 = Loadable(
  lazy(() => import("./AddprojCollaboratorsv2"))
);
const Addendorsementv2 = Loadable(lazy(() => import("./Addendorsementv2")));
const Endorsenow = Loadable(lazy(() => import("./Endorsenow")));
const AddendorseCard = Loadable(lazy(() => import("./AddendorseCard")));
const Howcanwehelp = Loadable(lazy(() => import("./Howcanwehelp")));
const ProfileRoutes = [
  { path: "/MyProfile/Basicinfo", element: <Basicinfo /> },
  { path: "/MyProfile/AddSkill", element: <AddSkills /> },
  { path: "/MyProfile/ChooseSkill", element: <ChooseSkill /> },
  { path: "/MyProfile/AddIndustryv1", element: <AddIndustryv1 /> },
  { path: "/MyProfile/PrimaryIndustry", element: <PrimaryIndustry /> },
  { path: "/MyProfile/AddProjectv2", element: <AddProjectv2 /> },
  {
    path: "/MyProfile/AddprojCollaboratorsv2",
    element: <AddprojCollaboratorsv2 />,
  },
  { path: "/MyProfile/Addendorsementv2", element: <Addendorsementv2 /> },
  { path: "/MyProfile/Endorsenow", element: <Endorsenow /> },
  { path: "/MyProfile/AddendorseCard", element: <AddendorseCard /> },
  {path: "/Myprofile/Howcanwehelp", element: <Howcanwehelp />}
];
export default ProfileRoutes;
